module.exports = __webpack_public_path__ + "img/温湿度传感器.3b736199.jpg";